import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    cellNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    website: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please provide an event date' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide a guest count' },
      ]
    },
    PartyName: {
      validations: [
        { type: 'required', message: 'Please provide a party name' },
      ]
    },
    StartTime: {
        validations: [
          { type: 'required', message: 'Please provide a start time' },
        ]
    },
    Description: {
        validations: [
          { type: 'required', message: 'Please provide a brief description of event' },
        ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Cell Number:*',
            mapping: 'cellNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Website:',
            mapping: 'website'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Planned Guest Count:*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Party Name:*',
            mapping: 'PartyName'
          }
        ]
      },
      {
        fields: [
          {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Start Time:*',
                options: [
                    { label: '7:30 AM', value: '07:30:00' },
                    { label: '8:00 AM', value: '08:00:00' },
                    { label: '8:30 AM', value: '08:30:00' },
                    { label: '9:00 AM', value: '09:00:00' },
                    { label: '9:30 AM', value: '09:30:00' },
                    { label: '10:00 AM', value: '10:00:00' },
                    { label: '10:30 AM', value: '10:30:00' },
                    { label: '11:00 AM', value: '11:00:00' },
                    { label: '11:30 AM', value: '11:30:00' },
                    { label: '12:00 PM', value: '12:00:00' },
                    { label: '12:30 PM', value: '12:30:00' },
                    { label: '1:00 PM', value: '13:00:00' },
                    { label: '1:30 PM', value: '13:30:00' },
                    { label: '2:00 PM', value: '14:00:00' },
                    { label: '2:30 PM', value: '14:30:00' },
                    { label: '3:00 PM', value: '15:00:00' },
                    { label: '3:30 PM', value: '15:30:00' },
                    { label: '4:00 PM', value: '16:00:00' },
                    { label: '4:30 PM', value: '16:30:00' },
                    { label: '5:00 PM', value: '17:00:00' },
                    { label: '5:30 PM', value: '17:30:00' },
                    { label: '6:00 PM', value: '18:00:00' },
                    { label: '6:30 PM', value: '18:30:00' },
                    { label: '7:00 PM', value: '19:00:00' },
                    { label: '7:30 PM', value: '19:30:00' },
                    { label: '8:00 PM', value: '20:00:00' },
                    { label: '8:30 PM', value: '20:30:00' },
                    { label: '9:00 PM', value: '21:00:00' },
                    { label: '9:30 PM', value: '21:30:00' },
                    { label: '10:00 PM', value: '22:00:00' },
                    { label: '10:30 PM', value: '22:30:00' },
                    { label: '11:00 PM', value: '23:00:00' },
                    { label: '11:30 PM', value: '23:30:00' },
                ],
                mapping: 'StartTime'
            }
        ]
    },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Brief Description of Services Needed:*',
            mapping: 'Description'
          }
        ]
      },
      {
        fields: [
            {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Details about the Event:',
            mapping: 'notes'
        }
    ]
    },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'First Americans Museum Contact Form',
    formId: '792',
    clientKey: '19430E09-1253-4F3F-BF8E-AC8915E4569D',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
